import { createContext } from 'react';
import { defaultConfigs as resetPasswordDefaults } from '@widgets/ResetPasswordForm/types/config';
import { defaultComponentConfig as giftVoucherDefaults } from '@widgets/GiftVoucherForn/types/config';
export const componentDefault = {
    currentTab: 'Details',
    headerTitle: 'My Account',
    backButton: {
        link: '/homepage.html',
        text: 'Go back',
    },
    detailsIcon: 'acco-payment',
    securityIcon: 'acco-payment',
    bookingsIcon: 'acco-payment',
    giftVouchersIcon: 'acco-payment',
    detailsTitle: 'Details',
    securityTitle: 'Security',
    bookingsTitle: 'Bookings',
    giftVouchersTitle: 'Gift Vouchers',
    usefulLinkTitle: 'Useful Links',
    usefulLinks: [
        {
            icon: 'profile',
            title: 'Customer Service',
            href: '/homepage.html',
        },
        {
            icon: 'gloves',
            title: 'What to Wear',
            href: '/homepage.html',
        },
        {
            icon: 'map-marker',
            title: 'How to find us',
            href: '/homepage.html',
        },
        {
            icon: 'profile',
            title: 'Terms & Conditions',
            href: '/homepage.html',
        },
    ],
    accountFormDefaults: {
        action: '/',
        email: undefined,
        firstName: undefined,
        surname: undefined,
        mobile: undefined,
        dateOfBirth: undefined,
        addressLine1: undefined,
        addressLine2: undefined,
        addressTown: undefined,
        addressCountry: undefined,
        addressPostcode: undefined,
        marketingPreferences: undefined,
        successUrl: undefined,
        marketingPreferenceText: 'I agree to receive marketing',
    },
    resetPasswordDefaults,
    giftVoucherDefaults,
    activeBookings: [],
    pastBookings: [],
    cancelBookingTitle: 'Are you sure you want to cancel?',
    cancelBookingCopy: 'Some text here about whether this can be reversed, whether they will get their money back etc. or info on what to do next, contact, etc.',
    pastBookingsTitle: 'Past Bookings',
    noActiveBookingsCopy: 'No Active Bookings Found',
};
export const OptionsCTX = createContext(componentDefault);
